export default {
  name: 'fontawesome-v5',
  icons: [
    { name: 'fa-500px', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-accessible-icon', prefix: 'fab', tags: ['accessibility', 'brand'] },
    { name: 'fa-accusoft', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-acquisitions-incorporated', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ad', prefix: 'fas', tags: ['social'] },
    { name: 'fa-address-book', prefix: 'fas', tags: ['office', 'people'] },
    { name: 'fa-address-card', prefix: 'fas', tags: ['office', 'people'] },
    { name: 'fa-adjust', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-adn', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-adversal', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-affiliatetheme', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-air-freshener', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-airbnb', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-algolia', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-align-center', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-align-justify', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-align-left', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-align-right', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-alipay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-allergies', prefix: 'fas', tags: ['health'] },
    { name: 'fa-amazon', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-amazon-pay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ambulance', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-american-sign-language-interpreting', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-amilia', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-anchor', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-android', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-angellist', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-angle-double-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-double-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-double-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-double-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angle-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-angry', prefix: 'fas', tags: ['emotions', 'people'] },
    { name: 'fa-angrycreative', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-angular', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ankh', prefix: 'fas', tags: ['religion', 'social'] },
    { name: 'fa-app-store', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-app-store-ios', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-apper', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-apple', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-apple-alt', prefix: 'fas', tags: ['brand', 'food'] },
    { name: 'fa-apple-pay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-archive', prefix: 'fas', tags: ['office'] },
    { name: 'fa-archway', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-arrow-alt-circle-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-alt-circle-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-alt-circle-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-alt-circle-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-circle-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-circle-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-circle-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-circle-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrow-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrows-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrows-alt-h', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-arrows-alt-v', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-artstation', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-assistive-listening-systems', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-asterisk', prefix: 'fas', tags: ['other'] },
    { name: 'fa-asymmetrik', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-at', prefix: 'fas', tags: ['web'] },
    { name: 'fa-atlas', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-atlassian', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-atom', prefix: 'fas', tags: ['science'] },
    { name: 'fa-audible', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-audio-description', prefix: 'fas', tags: ['accessibility', 'media'] },
    { name: 'fa-autoprefixer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-avianex', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-aviato', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-award', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-aws', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-baby', prefix: 'fas', tags: ['family', 'people'] },
    { name: 'fa-baby-carriage', prefix: 'fas', tags: ['family', 'people'] },
    { name: 'fa-backspace', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-backward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-bacon', prefix: 'fas', tags: ['food'] },
    { name: 'fa-bacteria', prefix: 'fas', tags: [] },
    { name: 'fa-bacterium', prefix: 'fas', tags: [] },
    { name: 'fa-bahai', prefix: 'fas', tags: [] },
    { name: 'fa-balance-scale', prefix: 'fas', tags: ['social'] },
    { name: 'fa-balance-scale-left', prefix: 'fas', tags: ['social'] },
    { name: 'fa-balance-scale-right', prefix: 'fas', tags: ['social'] },
    { name: 'fa-ban', prefix: 'fas', tags: ['social'] },
    { name: 'fa-band-aid', prefix: 'fas', tags: ['health'] },
    { name: 'fa-bandcamp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-barcode', prefix: 'fas', tags: ['other', 'technology'] },
    { name: 'fa-bars', prefix: 'fas', tags: ['web'] },
    { name: 'fa-baseball-ball', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-basketball-ball', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-bath', prefix: 'fas', tags: ['home'] },
    { name: 'fa-battery-empty', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-battery-full', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-battery-half', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-battery-quarter', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-battery-three-quarters', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-battle-net', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bed', prefix: 'fas', tags: ['home'] },
    { name: 'fa-beer', prefix: 'fas', tags: ['food'] },
    { name: 'fa-behance', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-behance-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bell', prefix: 'fas', tags: ['other'] },
    { name: 'fa-bell-slash', prefix: 'fas', tags: ['other'] },
    { name: 'fa-bezier-curve', prefix: 'fas', tags: ['science'] },
    { name: 'fa-bible', prefix: 'fas', tags: ['religion', 'social'] },
    { name: 'fa-bicycle', prefix: 'fas', tags: ['sport', 'travel'] },
    { name: 'fa-biking', prefix: 'fas', tags: ['sport', 'travel'] },
    { name: 'fa-bimobject', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-binoculars', prefix: 'fas', tags: ['other', 'travel'] },
    { name: 'fa-biohazard', prefix: 'fas', tags: ['other', 'science'] },
    { name: 'fa-birthday-cake', prefix: 'fas', tags: ['social'] },
    { name: 'fa-bitbucket', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bitcoin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bity', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-black-tie', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-blackberry', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-blender', prefix: 'fas', tags: ['home', 'technology'] },
    { name: 'fa-blender-phone', prefix: 'fas', tags: ['home', 'technology'] },
    { name: 'fa-blind', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-blog', prefix: 'fas', tags: ['web'] },
    { name: 'fa-blogger', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-blogger-b', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bluetooth', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bluetooth-b', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bold', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-bolt', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-bomb', prefix: 'fas', tags: ['other'] },
    { name: 'fa-bone', prefix: 'fas', tags: ['food'] },
    { name: 'fa-bong', prefix: 'fas', tags: ['science'] },
    { name: 'fa-book', prefix: 'fas', tags: ['social'] },
    { name: 'fa-book-dead', prefix: 'fas', tags: ['social'] },
    { name: 'fa-book-medical', prefix: 'fas', tags: ['health', 'social'] },
    { name: 'fa-book-open', prefix: 'fas', tags: ['social'] },
    { name: 'fa-book-reader', prefix: 'fas', tags: ['social'] },
    { name: 'fa-bookmark', prefix: 'fas', tags: ['other', 'web'] },
    { name: 'fa-bootstrap', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-border-all', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-border-none', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-border-style', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-bowling-ball', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-box', prefix: 'fas', tags: ['other'] },
    { name: 'fa-box-open', prefix: 'fas', tags: ['other'] },
    { name: 'fa-box-tissue', prefix: 'fas', tags: [] },
    { name: 'fa-boxes', prefix: 'fas', tags: ['other'] },
    { name: 'fa-braille', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-brain', prefix: 'fas', tags: ['health', 'health', 'social'] },
    { name: 'fa-bread-slice', prefix: 'fas', tags: ['food'] },
    { name: 'fa-briefcase', prefix: 'fas', tags: ['office'] },
    { name: 'fa-briefcase-medical', prefix: 'fas', tags: ['health'] },
    { name: 'fa-broadcast-tower', prefix: 'fas', tags: ['media'] },
    { name: 'fa-broom', prefix: 'fas', tags: ['home', 'other'] },
    { name: 'fa-brush', prefix: 'fas', tags: ['social'] },
    { name: 'fa-btc', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-buffer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bug', prefix: 'fas', tags: ['nature', 'web'] },
    { name: 'fa-building', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-bullhorn', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-bullseye', prefix: 'fas', tags: ['other'] },
    { name: 'fa-burn', prefix: 'fas', tags: ['other', 'social', 'web'] },
    { name: 'fa-buromobelexperte', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-bus', prefix: 'fas', tags: ['social', 'technology', 'travel'] },
    { name: 'fa-bus-alt', prefix: 'fas', tags: ['social', 'technology', 'travel'] },
    { name: 'fa-business-time', prefix: 'fas', tags: ['office'] },
    { name: 'fa-buy-n-large', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-buysellads', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-calculator', prefix: 'fas', tags: ['science'] },
    { name: 'fa-calendar', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-alt', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-check', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-day', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-minus', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-plus', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-times', prefix: 'fas', tags: ['office'] },
    { name: 'fa-calendar-week', prefix: 'fas', tags: ['office'] },
    { name: 'fa-camera', prefix: 'fas', tags: ['technology', 'web'] },
    { name: 'fa-camera-retro', prefix: 'fas', tags: ['technology', 'web'] },
    { name: 'fa-campground', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-canadian-maple-leaf', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-candy-cane', prefix: 'fas', tags: ['food'] },
    { name: 'fa-cannabis', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-capsules', prefix: 'fas', tags: ['health'] },
    { name: 'fa-car', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-car-alt', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-car-battery', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-car-crash', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-car-side', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-caravan', prefix: 'fas', tags: [] },
    { name: 'fa-caret-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-square-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-square-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-square-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-square-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-caret-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-carrot', prefix: 'fas', tags: ['food'] },
    { name: 'fa-cart-arrow-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-cart-plus', prefix: 'fas', tags: ['office'] },
    { name: 'fa-cash-register', prefix: 'fas', tags: ['money', 'technology'] },
    { name: 'fa-cat', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-cc-amazon-pay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-amex', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-apple-pay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-diners-club', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-discover', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-jcb', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-mastercard', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-paypal', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-stripe', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cc-visa', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-centercode', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-centos', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-certificate', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chair', prefix: 'fas', tags: ['home'] },
    { name: 'fa-chalkboard', prefix: 'fas', tags: ['office'] },
    { name: 'fa-chalkboard-teacher', prefix: 'fas', tags: ['office', 'other', 'science'] },
    { name: 'fa-charging-station', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-chart-area', prefix: 'fas', tags: ['office'] },
    { name: 'fa-chart-bar', prefix: 'fas', tags: ['office'] },
    { name: 'fa-chart-line', prefix: 'fas', tags: ['arrow', 'office'] },
    { name: 'fa-chart-pie', prefix: 'fas', tags: ['office'] },
    { name: 'fa-check', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-check-circle', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-check-double', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-check-square', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-cheese', prefix: 'fas', tags: ['food'] },
    { name: 'fa-chess', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-bishop', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-board', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-king', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-knight', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-pawn', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-queen', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chess-rook', prefix: 'fas', tags: ['social'] },
    { name: 'fa-chevron-circle-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-circle-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-circle-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-circle-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-chevron-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-child', prefix: 'fas', tags: ['family', 'people'] },
    { name: 'fa-chrome', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-chromecast', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-church', prefix: 'fas', tags: ['buildings', 'social'] },
    { name: 'fa-circle', prefix: 'fas', tags: ['media', 'other'] },
    { name: 'fa-circle-notch', prefix: 'fas', tags: ['other'] },
    { name: 'fa-city', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-clinic-medical', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-clipboard', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-clipboard-check', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-clipboard-list', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-clock', prefix: 'fas', tags: ['home', 'office', 'other'] },
    { name: 'fa-clone', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-closed-captioning', prefix: 'fas', tags: ['accessibility', 'media'] },
    { name: 'fa-cloud', prefix: 'fas', tags: ['weather', 'web'] },
    { name: 'fa-cloud-download-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-cloud-meatball', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-moon', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-moon-rain', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-rain', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-showers-heavy', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-sun', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-sun-rain', prefix: 'fas', tags: ['weather'] },
    { name: 'fa-cloud-upload-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-cloudflare', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cloudscale', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cloudsmith', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cloudversify', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cocktail', prefix: 'fas', tags: ['food'] },
    { name: 'fa-code', prefix: 'fas', tags: ['technology', 'web'] },
    { name: 'fa-code-branch', prefix: 'fas', tags: ['technology', 'web'] },
    { name: 'fa-codepen', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-codiepie', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-coffee', prefix: 'fas', tags: ['food'] },
    { name: 'fa-cog', prefix: 'fas', tags: ['other', 'technology'] },
    { name: 'fa-cogs', prefix: 'fas', tags: ['other', 'technology'] },
    { name: 'fa-coins', prefix: 'fas', tags: ['money', 'social'] },
    { name: 'fa-columns', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-comment', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comment-alt', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comment-dollar', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comment-dots', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comment-medical', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comment-slash', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comments', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-comments-dollar', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-compact-disc', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-compass', prefix: 'fas', tags: ['social', 'travel', 'weather'] },
    { name: 'fa-compress', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-compress-alt', prefix: 'fas', tags: [] },
    { name: 'fa-compress-arrows-alt', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-concierge-bell', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-confluence', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-connectdevelop', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-contao', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-cookie', prefix: 'fas', tags: ['food'] },
    { name: 'fa-cookie-bite', prefix: 'fas', tags: ['food'] },
    { name: 'fa-copy', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-copyright', prefix: 'fas', tags: ['social'] },
    { name: 'fa-cotton-bureau', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-couch', prefix: 'fas', tags: ['home'] },
    { name: 'fa-cpanel', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-by', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-nc', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-nc-eu', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-nc-jp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-nd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-pd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-pd-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-remix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-sa', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-sampling', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-sampling-plus', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-share', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-creative-commons-zero', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-credit-card', prefix: 'fas', tags: ['money', 'social'] },
    { name: 'fa-critical-role', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-crop', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-crop-alt', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-cross', prefix: 'fas', tags: ['religion'] },
    { name: 'fa-crosshairs', prefix: 'fas', tags: ['other'] },
    { name: 'fa-crow', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-crown', prefix: 'fas', tags: ['social'] },
    { name: 'fa-crutch', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-css3', prefix: 'fab', tags: ['brand', 'web'] },
    { name: 'fa-css3-alt', prefix: 'fab', tags: ['brand', 'web'] },
    { name: 'fa-cube', prefix: 'fas', tags: ['other'] },
    { name: 'fa-cubes', prefix: 'fas', tags: ['other'] },
    { name: 'fa-cut', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-cuttlefish', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-d-and-d', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-d-and-d-beyond', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dailymotion', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dashcube', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-database', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-deaf', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-deezer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-delicious', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-democrat', prefix: 'fas', tags: ['other'] },
    { name: 'fa-deploydog', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-deskpro', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-desktop', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-dev', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-deviantart', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dharmachakra', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-dhl', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-diagnoses', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-diaspora', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dice', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-d20', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-d6', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-five', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-four', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-one', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-six', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-three', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dice-two', prefix: 'fas', tags: ['other'] },
    { name: 'fa-digg', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-digital-ocean', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-digital-tachograph', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-directions', prefix: 'fas', tags: ['social'] },
    { name: 'fa-discord', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-discourse', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-disease', prefix: 'fas', tags: [] },
    { name: 'fa-divide', prefix: 'fas', tags: ['science'] },
    { name: 'fa-dizzy', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-dna', prefix: 'fas', tags: ['science'] },
    { name: 'fa-dochub', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-docker', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dog', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-dollar-sign', prefix: 'fas', tags: ['money'] },
    { name: 'fa-dolly', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-dolly-flatbed', prefix: 'fas', tags: ['other', 'travel'] },
    { name: 'fa-donate', prefix: 'fas', tags: ['social'] },
    { name: 'fa-door-closed', prefix: 'fas', tags: ['home', 'web'] },
    { name: 'fa-door-open', prefix: 'fas', tags: ['home', 'web'] },
    { name: 'fa-dot-circle', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dove', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-download', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-draft2digital', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-drafting-compass', prefix: 'fas', tags: ['science', 'travel'] },
    { name: 'fa-dragon', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-draw-polygon', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-dribbble', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dribbble-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dropbox', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-drum', prefix: 'fas', tags: ['social'] },
    { name: 'fa-drum-steelpan', prefix: 'fas', tags: ['social'] },
    { name: 'fa-drumstick-bite', prefix: 'fas', tags: ['social'] },
    { name: 'fa-drupal', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-dumbbell', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-dumpster', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dumpster-fire', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dungeon', prefix: 'fas', tags: ['other'] },
    { name: 'fa-dyalog', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-earlybirds', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ebay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-edge', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-edge-legacy', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-edit', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-egg', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-eject', prefix: 'fas', tags: ['media'] },
    { name: 'fa-elementor', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ellipsis-h', prefix: 'fas', tags: ['science'] },
    { name: 'fa-ellipsis-v', prefix: 'fas', tags: ['science'] },
    { name: 'fa-ello', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ember', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-empire', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-envelope', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-envelope-open', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-envelope-open-text', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-envelope-square', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-envira', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-equals', prefix: 'fas', tags: ['science'] },
    { name: 'fa-eraser', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-erlang', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ethereum', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ethernet', prefix: 'fas', tags: ['technology', 'web'] },
    { name: 'fa-etsy', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-euro-sign', prefix: 'fas', tags: ['money'] },
    { name: 'fa-evernote', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-exchange-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-exclamation', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-exclamation-circle', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-exclamation-triangle', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-expand', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-expand-alt', prefix: 'fas', tags: [] },
    { name: 'fa-expand-arrows-alt', prefix: 'fas', tags: ['media'] },
    { name: 'fa-expeditedssl', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-external-link-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-external-link-square-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-eye', prefix: 'fas', tags: ['health', 'people', 'social'] },
    { name: 'fa-eye-dropper', prefix: 'fas', tags: ['health'] },
    { name: 'fa-eye-slash', prefix: 'fas', tags: ['health', 'social'] },
    { name: 'fa-facebook', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-facebook-f', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-facebook-messenger', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-facebook-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fan', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-fantasy-flight-games', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fast-backward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-fast-forward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-faucet', prefix: 'fas', tags: [] },
    { name: 'fa-fax', prefix: 'fas', tags: ['office', 'technology'] },
    { name: 'fa-feather', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-feather-alt', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-fedex', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fedora', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-female', prefix: 'fas', tags: ['people'] },
    { name: 'fa-fighter-jet', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-figma', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-file', prefix: 'fas', tags: ['computer', 'editor'] },
    { name: 'fa-file-alt', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-file-archive', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-audio', prefix: 'fas', tags: ['media'] },
    { name: 'fa-file-code', prefix: 'fas', tags: ['computer', 'editor'] },
    { name: 'fa-file-contract', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-csv', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-download', prefix: 'fas', tags: ['computer', 'web'] },
    { name: 'fa-file-excel', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-file-export', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-image', prefix: 'fas', tags: ['computer', 'media'] },
    { name: 'fa-file-import', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-invoice', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-file-invoice-dollar', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-file-medical', prefix: 'fas', tags: ['computer', 'health'] },
    { name: 'fa-file-medical-alt', prefix: 'fas', tags: ['computer', 'health'] },
    { name: 'fa-file-pdf', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-file-powerpoint', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-file-prescription', prefix: 'fas', tags: ['computer', 'health'] },
    { name: 'fa-file-signature', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-file-upload', prefix: 'fas', tags: ['computer', 'web'] },
    { name: 'fa-file-video', prefix: 'fas', tags: ['computer', 'media'] },
    { name: 'fa-file-word', prefix: 'fas', tags: ['computer', 'office'] },
    { name: 'fa-fill', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-fill-drip', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-film', prefix: 'fas', tags: ['media'] },
    { name: 'fa-filter', prefix: 'fas', tags: ['web'] },
    { name: 'fa-fingerprint', prefix: 'fas', tags: ['computer', 'technology'] },
    { name: 'fa-fire', prefix: 'fas', tags: ['nature', 'social', 'travel', 'web'] },
    { name: 'fa-fire-alt', prefix: 'fas', tags: ['nature', 'social', 'travel', 'web'] },
    { name: 'fa-fire-extinguisher', prefix: 'fas', tags: ['social', 'technology'] },
    { name: 'fa-firefox', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-firefox-browser', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-first-aid', prefix: 'fas', tags: ['health'] },
    { name: 'fa-first-order', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-first-order-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-firstdraft', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fish', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-fist-raised', prefix: 'fas', tags: ['social'] },
    { name: 'fa-flag', prefix: 'fas', tags: ['social'] },
    { name: 'fa-flag-checkered', prefix: 'fas', tags: ['social'] },
    { name: 'fa-flag-usa', prefix: 'fas', tags: ['social'] },
    { name: 'fa-flask', prefix: 'fas', tags: ['science'] },
    { name: 'fa-flickr', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-flipboard', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-flushed', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-fly', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-folder', prefix: 'fas', tags: ['computer', 'office', 'web'] },
    { name: 'fa-folder-minus', prefix: 'fas', tags: ['computer', 'office', 'web'] },
    { name: 'fa-folder-open', prefix: 'fas', tags: ['computer', 'office', 'web'] },
    { name: 'fa-folder-plus', prefix: 'fas', tags: ['computer', 'office', 'web'] },
    { name: 'fa-font', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-font-awesome', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-font-awesome-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-font-awesome-flag', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fonticons', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fonticons-fi', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-football-ball', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-fort-awesome', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-fort-awesome-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-forumbee', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-forward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-foursquare', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-free-code-camp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-freebsd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-frog', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-frown', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-frown-open', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-fulcrum', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-funnel-dollar', prefix: 'fas', tags: ['money'] },
    { name: 'fa-futbol', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-galactic-republic', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-galactic-senate', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gamepad', prefix: 'fas', tags: ['social'] },
    { name: 'fa-gas-pump', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-gavel', prefix: 'fas', tags: ['social'] },
    { name: 'fa-gem', prefix: 'fas', tags: ['other'] },
    { name: 'fa-genderless', prefix: 'fas', tags: ['other'] },
    { name: 'fa-get-pocket', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gg', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gg-circle', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ghost', prefix: 'fas', tags: ['other'] },
    { name: 'fa-gift', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-gifts', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-git', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-git-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-git-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-github', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-github-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-github-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gitkraken', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gitlab', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gitter', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-glass-cheers', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-glass-martini', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-glass-martini-alt', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-glass-whiskey', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-glasses', prefix: 'fas', tags: ['food', 'social'] },
    { name: 'fa-glide', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-glide-g', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-globe', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-globe-africa', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-globe-americas', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-globe-asia', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-globe-europe', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-gofore', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-golf-ball', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-goodreads', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-goodreads-g', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-drive', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-pay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-play', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-plus', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-plus-g', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-plus-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-google-wallet', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-gopuram', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-graduation-cap', prefix: 'fas', tags: ['science', 'social'] },
    { name: 'fa-gratipay', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-grav', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-greater-than', prefix: 'fas', tags: ['science'] },
    { name: 'fa-greater-than-equal', prefix: 'fas', tags: ['science'] },
    { name: 'fa-grimace', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-alt', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-beam', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-beam-sweat', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-hearts', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-squint', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-squint-tears', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-stars', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-tears', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-tongue', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-tongue-squint', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-tongue-wink', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grin-wink', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grip-horizontal', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grip-lines', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grip-lines-vertical', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-grip-vertical', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-gripfire', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-grunt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-guilded', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-guitar', prefix: 'fas', tags: ['social', 'travel'] },
    { name: 'fa-gulp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-h-square', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-hacker-news', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hacker-news-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hackerrank', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hamburger', prefix: 'fas', tags: ['food'] },
    { name: 'fa-hammer', prefix: 'fas', tags: ['other'] },
    { name: 'fa-hamsa', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hand-holding', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-holding-heart', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-holding-medical', prefix: 'fas', tags: [] },
    { name: 'fa-hand-holding-usd', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-holding-water', prefix: 'fas', tags: [] },
    { name: 'fa-hand-lizard', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-middle-finger', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-paper', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-peace', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-point-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hand-point-down', prefix: 'far', tags: ['arrow'] },
    { name: 'fa-hand-point-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hand-point-left', prefix: 'far', tags: ['arrow'] },
    { name: 'fa-hand-point-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hand-point-right', prefix: 'far', tags: ['arrow'] },
    { name: 'fa-hand-point-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hand-point-up', prefix: 'far', tags: ['arrow'] },
    { name: 'fa-hand-pointer', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hand-pointer', prefix: 'far', tags: ['arrow'] },
    { name: 'fa-hand-rock', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-scissors', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hand-sparkles', prefix: 'fas', tags: [] },
    { name: 'fa-hand-spock', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hands', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hands-helping', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hands-wash', prefix: 'fas', tags: [] },
    { name: 'fa-handshake', prefix: 'fas', tags: ['social'] },
    { name: 'fa-handshake-alt-slash', prefix: 'fas', tags: [] },
    { name: 'fa-handshake-slash', prefix: 'fas', tags: [] },
    { name: 'fa-hanukiah', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hard-hat', prefix: 'fas', tags: ['social'] },
    { name: 'fa-hashtag', prefix: 'fas', tags: ['web'] },
    { name: 'fa-hat-cowboy', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hat-cowboy-side', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hat-wizard', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hdd', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-head-side-cough', prefix: 'fas', tags: [] },
    { name: 'fa-head-side-cough-slash', prefix: 'fas', tags: [] },
    { name: 'fa-head-side-mask', prefix: 'fas', tags: [] },
    { name: 'fa-head-side-virus', prefix: 'fas', tags: [] },
    { name: 'fa-heading', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-headphones', prefix: 'fas', tags: ['media'] },
    { name: 'fa-headphones-alt', prefix: 'fas', tags: ['media'] },
    { name: 'fa-headset', prefix: 'fas', tags: ['computer', 'office', 'technology'] },
    { name: 'fa-heart', prefix: 'fas', tags: ['social'] },
    { name: 'fa-heart-broken', prefix: 'fas', tags: ['social'] },
    { name: 'fa-heartbeat', prefix: 'fas', tags: ['health'] },
    { name: 'fa-helicopter', prefix: 'fas', tags: ['technology'] },
    { name: 'fa-highlighter', prefix: 'fas', tags: ['art', 'social'] },
    { name: 'fa-hiking', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-hippo', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-hips', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hire-a-helper', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-history', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-hive', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hockey-puck', prefix: 'fas', tags: ['sport'] },
    { name: 'fa-holly-berry', prefix: 'fas', tags: ['social'] },
    { name: 'fa-home', prefix: 'fas', tags: ['buildings', 'web'] },
    { name: 'fa-hooli', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hornbill', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-horse', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-horse-head', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-hospital', prefix: 'fas', tags: ['health'] },
    { name: 'fa-hospital-alt', prefix: 'fas', tags: ['health'] },
    { name: 'fa-hospital-symbol', prefix: 'fas', tags: ['health'] },
    { name: 'fa-hospital-user', prefix: 'fas', tags: [] },
    { name: 'fa-hot-tub', prefix: 'fas', tags: ['home'] },
    { name: 'fa-hotdog', prefix: 'fas', tags: ['food'] },
    { name: 'fa-hotel', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-hotjar', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hourglass', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hourglass-end', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hourglass-half', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-hourglass-start', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-house-damage', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-house-user', prefix: 'fas', tags: [] },
    { name: 'fa-houzz', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hryvnia', prefix: 'fas', tags: ['money'] },
    { name: 'fa-html5', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-hubspot', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-i-cursor', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-ice-cream', prefix: 'fas', tags: ['food'] },
    { name: 'fa-icicles', prefix: 'fas', tags: ['other', 'travel'] },
    { name: 'fa-icons', prefix: 'fas', tags: ['computer', 'web'] },
    { name: 'fa-id-badge', prefix: 'fas', tags: ['social'] },
    { name: 'fa-id-card', prefix: 'fas', tags: ['social'] },
    { name: 'fa-id-card-alt', prefix: 'fas', tags: ['social'] },
    { name: 'fa-ideal', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-igloo', prefix: 'fas', tags: ['buildings', 'travel'] },
    { name: 'fa-image', prefix: 'fas', tags: ['computer', 'web'] },
    { name: 'fa-images', prefix: 'fas', tags: ['computer', 'web'] },
    { name: 'fa-imdb', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-inbox', prefix: 'fas', tags: ['other', 'web'] },
    { name: 'fa-indent', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-industry', prefix: 'fas', tags: ['buildings', 'technology'] },
    { name: 'fa-infinity', prefix: 'fas', tags: ['science'] },
    { name: 'fa-info', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-info-circle', prefix: 'fas', tags: ['office', 'social', 'web'] },
    { name: 'fa-innosoft', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-instagram', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-instagram-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-instalod', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-intercom', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-internet-explorer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-invision', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ioxhost', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-italic', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-itch-io', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-itunes', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-itunes-note', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-java', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-jedi', prefix: 'fas', tags: ['other', 'social'] },
    { name: 'fa-jedi-order', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-jenkins', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-jira', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-joget', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-joint', prefix: 'fas', tags: ['social'] },
    { name: 'fa-joomla', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-journal-whills', prefix: 'fas', tags: ['social'] },
    { name: 'fa-js', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-js-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-jsfiddle', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-kaaba', prefix: 'fas', tags: ['social'] },
    { name: 'fa-kaggle', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-key', prefix: 'fas', tags: ['computer', 'social', 'web'] },
    { name: 'fa-keybase', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-keyboard', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-keycdn', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-khanda', prefix: 'fas', tags: ['social'] },
    { name: 'fa-kickstarter', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-kickstarter-k', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-kiss', prefix: 'fas', tags: ['emotions', 'family'] },
    { name: 'fa-kiss-beam', prefix: 'fas', tags: ['emotions', 'family'] },
    { name: 'fa-kiss-wink-heart', prefix: 'fas', tags: ['emotions', 'family'] },
    { name: 'fa-kiwi-bird', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-korvue', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-landmark', prefix: 'fas', tags: ['buildings'] },
    { name: 'fa-language', prefix: 'fas', tags: ['social', 'travel', 'web'] },
    { name: 'fa-laptop', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-laptop-code', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-laptop-house', prefix: 'fas', tags: [] },
    { name: 'fa-laptop-medical', prefix: 'fas', tags: ['computer', 'health'] },
    { name: 'fa-laravel', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-lastfm', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-lastfm-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-laugh', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-laugh-beam', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-laugh-squint', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-laugh-wink', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-layer-group', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-leaf', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-leanpub', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-lemon', prefix: 'fas', tags: ['brand'] },
    { name: 'fa-less', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-less-than', prefix: 'fas', tags: ['science'] },
    { name: 'fa-less-than-equal', prefix: 'fas', tags: ['science'] },
    { name: 'fa-level-down-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-level-up-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-life-ring', prefix: 'fas', tags: ['social'] },
    { name: 'fa-lightbulb', prefix: 'fas', tags: ['art', 'technology'] },
    { name: 'fa-line', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-link', prefix: 'fas', tags: ['editor', 'web'] },
    { name: 'fa-linkedin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-linkedin-in', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-linode', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-linux', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-lira-sign', prefix: 'fas', tags: ['money'] },
    { name: 'fa-list', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-list-alt', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-list-ol', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-list-ul', prefix: 'fas', tags: ['editor'] },
    { name: 'fa-location-arrow', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-lock', prefix: 'fas', tags: ['computer', 'social', 'web'] },
    { name: 'fa-lock-open', prefix: 'fas', tags: ['computer', 'social', 'web'] },
    { name: 'fa-long-arrow-alt-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-long-arrow-alt-left', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-long-arrow-alt-right', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-long-arrow-alt-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-low-vision', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-luggage-cart', prefix: 'fas', tags: ['technology', 'travel'] },
    { name: 'fa-lungs', prefix: 'fas', tags: [] },
    { name: 'fa-lungs-virus', prefix: 'fas', tags: [] },
    { name: 'fa-lyft', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-magento', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-magic', prefix: 'fas', tags: ['social'] },
    { name: 'fa-magnet', prefix: 'fas', tags: ['science', 'technology'] },
    { name: 'fa-mail-bulk', prefix: 'fas', tags: ['office', 'social'] },
    { name: 'fa-mailchimp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-male', prefix: 'fas', tags: ['people'] },
    { name: 'fa-mandalorian', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-map', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-marked', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-marked-alt', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-marker', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-marker-alt', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-pin', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-map-signs', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-markdown', prefix: 'fab', tags: ['brand', 'editor'] },
    { name: 'fa-marker', prefix: 'fas', tags: ['editor', 'office'] },
    { name: 'fa-mars', prefix: 'fas', tags: ['social'] },
    { name: 'fa-mars-double', prefix: 'fas', tags: ['social'] },
    { name: 'fa-mars-stroke', prefix: 'fas', tags: ['social'] },
    { name: 'fa-mars-stroke-h', prefix: 'fas', tags: ['social'] },
    { name: 'fa-mars-stroke-v', prefix: 'fas', tags: ['social'] },
    { name: 'fa-mask', prefix: 'fas', tags: ['social', 'web'] },
    { name: 'fa-mastodon', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-maxcdn', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-mdb', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-medal', prefix: 'fas', tags: ['social'] },
    { name: 'fa-medapps', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-medium', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-medium-m', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-medkit', prefix: 'fas', tags: ['health'] },
    { name: 'fa-medrt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-meetup', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-megaport', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-meh', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-meh-blank', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-meh-rolling-eyes', prefix: 'fas', tags: ['emotions'] },
    { name: 'fa-memory', prefix: 'fas', tags: ['computer'] },
    { name: 'fa-mendeley', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-menorah', prefix: 'fas', tags: [] },
    { name: 'fa-mercury', prefix: 'fas', tags: [] },
    { name: 'fa-meteor', prefix: 'fas', tags: [] },
    { name: 'fa-microblog', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-microchip', prefix: 'fas', tags: [] },
    { name: 'fa-microphone', prefix: 'fas', tags: ['media'] },
    { name: 'fa-microphone-alt', prefix: 'fas', tags: ['media'] },
    { name: 'fa-microphone-alt-slash', prefix: 'fas', tags: ['media'] },
    { name: 'fa-microphone-slash', prefix: 'fas', tags: ['media'] },
    { name: 'fa-microscope', prefix: 'fas', tags: [] },
    { name: 'fa-microsoft', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-minus', prefix: 'fas', tags: [] },
    { name: 'fa-minus-circle', prefix: 'fas', tags: [] },
    { name: 'fa-minus-square', prefix: 'fas', tags: [] },
    { name: 'fa-mitten', prefix: 'fas', tags: [] },
    { name: 'fa-mix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-mixcloud', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-mixer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-mizuni', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-mobile', prefix: 'fas', tags: [] },
    { name: 'fa-mobile-alt', prefix: 'fas', tags: [] },
    { name: 'fa-modx', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-monero', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-money-bill', prefix: 'fas', tags: [] },
    { name: 'fa-money-bill-alt', prefix: 'fas', tags: [] },
    { name: 'fa-money-bill-wave', prefix: 'fas', tags: [] },
    { name: 'fa-money-bill-wave-alt', prefix: 'fas', tags: [] },
    { name: 'fa-money-check', prefix: 'fas', tags: [] },
    { name: 'fa-money-check-alt', prefix: 'fas', tags: [] },
    { name: 'fa-monument', prefix: 'fas', tags: [] },
    { name: 'fa-moon', prefix: 'fas', tags: [] },
    { name: 'fa-mortar-pestle', prefix: 'fas', tags: [] },
    { name: 'fa-mosque', prefix: 'fas', tags: [] },
    { name: 'fa-motorcycle', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-mountain', prefix: 'fas', tags: [] },
    { name: 'fa-mouse', prefix: 'fas', tags: [] },
    { name: 'fa-mouse-pointer', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-mug-hot', prefix: 'fas', tags: [] },
    { name: 'fa-music', prefix: 'fas', tags: ['media'] },
    { name: 'fa-napster', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-neos', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-network-wired', prefix: 'fas', tags: [] },
    { name: 'fa-neuter', prefix: 'fas', tags: [] },
    { name: 'fa-newspaper', prefix: 'fas', tags: [] },
    { name: 'fa-nimblr', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-node', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-node-js', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-not-equal', prefix: 'fas', tags: [] },
    { name: 'fa-notes-medical', prefix: 'fas', tags: [] },
    { name: 'fa-npm', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ns8', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-nutritionix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-object-group', prefix: 'fas', tags: [] },
    { name: 'fa-object-ungroup', prefix: 'fas', tags: [] },
    { name: 'fa-octopus-deploy', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-odnoklassniki', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-odnoklassniki-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-oil-can', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-old-republic', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-om', prefix: 'fas', tags: [] },
    { name: 'fa-opencart', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-openid', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-opera', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-optin-monster', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-orcid', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-osi', prefix: 'fas', tags: [] },
    { name: 'fa-otter', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-outdent', prefix: 'fas', tags: [] },
    { name: 'fa-page4', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pagelines', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pager', prefix: 'fas', tags: [] },
    { name: 'fa-paint-brush', prefix: 'fas', tags: [] },
    { name: 'fa-paint-roller', prefix: 'fas', tags: [] },
    { name: 'fa-palette', prefix: 'fas', tags: [] },
    { name: 'fa-palfed', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pallet', prefix: 'fas', tags: [] },
    { name: 'fa-paper-plane', prefix: 'fas', tags: [] },
    { name: 'fa-paperclip', prefix: 'fas', tags: [] },
    { name: 'fa-parachute-box', prefix: 'fas', tags: [] },
    { name: 'fa-paragraph', prefix: 'fas', tags: [] },
    { name: 'fa-parking', prefix: 'fas', tags: [] },
    { name: 'fa-passport', prefix: 'fas', tags: [] },
    { name: 'fa-pastafarianism', prefix: 'fas', tags: [] },
    { name: 'fa-paste', prefix: 'fas', tags: [] },
    { name: 'fa-patreon', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pause', prefix: 'fas', tags: ['media'] },
    { name: 'fa-pause-circle', prefix: 'fas', tags: ['media'] },
    { name: 'fa-paw', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-paypal', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-peace', prefix: 'fas', tags: [] },
    { name: 'fa-pen', prefix: 'fas', tags: [] },
    { name: 'fa-pen-alt', prefix: 'fas', tags: [] },
    { name: 'fa-pen-fancy', prefix: 'fas', tags: [] },
    { name: 'fa-pen-nib', prefix: 'fas', tags: [] },
    { name: 'fa-pen-square', prefix: 'fas', tags: [] },
    { name: 'fa-pencil-alt', prefix: 'fas', tags: [] },
    { name: 'fa-pencil-ruler', prefix: 'fas', tags: [] },
    { name: 'fa-penny-arcade', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-people-arrows', prefix: 'fas', tags: [] },
    { name: 'fa-people-carry', prefix: 'fas', tags: [] },
    { name: 'fa-pepper-hot', prefix: 'fas', tags: [] },
    { name: 'fa-perbyte', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-percent', prefix: 'fas', tags: [] },
    { name: 'fa-percentage', prefix: 'fas', tags: [] },
    { name: 'fa-periscope', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-person-booth', prefix: 'fas', tags: [] },
    { name: 'fa-phabricator', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-phoenix-framework', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-phoenix-squadron', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-phone', prefix: 'fas', tags: [] },
    { name: 'fa-phone-alt', prefix: 'fas', tags: [] },
    { name: 'fa-phone-slash', prefix: 'fas', tags: [] },
    { name: 'fa-phone-square', prefix: 'fas', tags: [] },
    { name: 'fa-phone-square-alt', prefix: 'fas', tags: [] },
    { name: 'fa-phone-volume', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-photo-video', prefix: 'fas', tags: [] },
    { name: 'fa-php', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pied-piper', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pied-piper-alt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pied-piper-hat', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pied-piper-pp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pied-piper-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-piggy-bank', prefix: 'fas', tags: [] },
    { name: 'fa-pills', prefix: 'fas', tags: [] },
    { name: 'fa-pinterest', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pinterest-p', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pinterest-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-pizza-slice', prefix: 'fas', tags: [] },
    { name: 'fa-place-of-worship', prefix: 'fas', tags: [] },
    { name: 'fa-plane', prefix: 'fas', tags: [] },
    { name: 'fa-plane-arrival', prefix: 'fas', tags: [] },
    { name: 'fa-plane-departure', prefix: 'fas', tags: [] },
    { name: 'fa-plane-slash', prefix: 'fas', tags: [] },
    { name: 'fa-play', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-play-circle', prefix: 'fas', tags: ['media'] },
    { name: 'fa-playstation', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-plug', prefix: 'fas', tags: [] },
    { name: 'fa-plus', prefix: 'fas', tags: [] },
    { name: 'fa-plus-circle', prefix: 'fas', tags: [] },
    { name: 'fa-plus-square', prefix: 'fas', tags: [] },
    { name: 'fa-podcast', prefix: 'fas', tags: ['media'] },
    { name: 'fa-poll', prefix: 'fas', tags: [] },
    { name: 'fa-poll-h', prefix: 'fas', tags: [] },
    { name: 'fa-poo', prefix: 'fas', tags: [] },
    { name: 'fa-poo-storm', prefix: 'fas', tags: [] },
    { name: 'fa-poop', prefix: 'fas', tags: [] },
    { name: 'fa-portrait', prefix: 'fas', tags: [] },
    { name: 'fa-pound-sign', prefix: 'fas', tags: [] },
    { name: 'fa-power-off', prefix: 'fas', tags: [] },
    { name: 'fa-pray', prefix: 'fas', tags: [] },
    { name: 'fa-praying-hands', prefix: 'fas', tags: [] },
    { name: 'fa-prescription', prefix: 'fas', tags: [] },
    { name: 'fa-prescription-bottle', prefix: 'fas', tags: [] },
    { name: 'fa-prescription-bottle-alt', prefix: 'fas', tags: [] },
    { name: 'fa-print', prefix: 'fas', tags: [] },
    { name: 'fa-procedures', prefix: 'fas', tags: [] },
    { name: 'fa-product-hunt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-project-diagram', prefix: 'fas', tags: [] },
    { name: 'fa-pump-medical', prefix: 'fas', tags: [] },
    { name: 'fa-pump-soap', prefix: 'fas', tags: [] },
    { name: 'fa-pushed', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-puzzle-piece', prefix: 'fas', tags: [] },
    { name: 'fa-python', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-qq', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-qrcode', prefix: 'fas', tags: [] },
    { name: 'fa-question', prefix: 'fas', tags: [] },
    { name: 'fa-question-circle', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-quidditch', prefix: 'fas', tags: [] },
    { name: 'fa-quinscape', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-quora', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-quote-left', prefix: 'fas', tags: [] },
    { name: 'fa-quote-right', prefix: 'fas', tags: [] },
    { name: 'fa-quran', prefix: 'fas', tags: [] },
    { name: 'fa-r-project', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-radiation', prefix: 'fas', tags: [] },
    { name: 'fa-radiation-alt', prefix: 'fas', tags: [] },
    { name: 'fa-rainbow', prefix: 'fas', tags: [] },
    { name: 'fa-random', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-raspberry-pi', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ravelry', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-react', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-reacteurope', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-readme', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-rebel', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-receipt', prefix: 'fas', tags: [] },
    { name: 'fa-record-vinyl', prefix: 'fas', tags: [] },
    { name: 'fa-recycle', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-red-river', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-reddit', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-reddit-alien', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-reddit-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-redhat', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-redo', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-redo-alt', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-registered', prefix: 'fas', tags: [] },
    { name: 'fa-remove-format', prefix: 'fas', tags: [] },
    { name: 'fa-renren', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-reply', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-reply-all', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-replyd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-republican', prefix: 'fas', tags: [] },
    { name: 'fa-researchgate', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-resolving', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-restroom', prefix: 'fas', tags: [] },
    { name: 'fa-retweet', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-rev', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ribbon', prefix: 'fas', tags: [] },
    { name: 'fa-ring', prefix: 'fas', tags: [] },
    { name: 'fa-road', prefix: 'fas', tags: [] },
    { name: 'fa-robot', prefix: 'fas', tags: [] },
    { name: 'fa-rocket', prefix: 'fas', tags: [] },
    { name: 'fa-rocketchat', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-rockrms', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-route', prefix: 'fas', tags: [] },
    { name: 'fa-rss', prefix: 'fas', tags: ['media'] },
    { name: 'fa-rss-square', prefix: 'fas', tags: ['media'] },
    { name: 'fa-ruble-sign', prefix: 'fas', tags: [] },
    { name: 'fa-ruler', prefix: 'fas', tags: [] },
    { name: 'fa-ruler-combined', prefix: 'fas', tags: [] },
    { name: 'fa-ruler-horizontal', prefix: 'fas', tags: [] },
    { name: 'fa-ruler-vertical', prefix: 'fas', tags: [] },
    { name: 'fa-running', prefix: 'fas', tags: [] },
    { name: 'fa-rupee-sign', prefix: 'fas', tags: [] },
    { name: 'fa-rust', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sad-cry', prefix: 'fas', tags: [] },
    { name: 'fa-sad-tear', prefix: 'fas', tags: [] },
    { name: 'fa-safari', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-salesforce', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sass', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-satellite', prefix: 'fas', tags: [] },
    { name: 'fa-satellite-dish', prefix: 'fas', tags: [] },
    { name: 'fa-save', prefix: 'fas', tags: [] },
    { name: 'fa-schlix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-school', prefix: 'fas', tags: [] },
    { name: 'fa-screwdriver', prefix: 'fas', tags: [] },
    { name: 'fa-scribd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-scroll', prefix: 'fas', tags: [] },
    { name: 'fa-sd-card', prefix: 'fas', tags: [] },
    { name: 'fa-search', prefix: 'fas', tags: [] },
    { name: 'fa-search-dollar', prefix: 'fas', tags: [] },
    { name: 'fa-search-location', prefix: 'fas', tags: [] },
    { name: 'fa-search-minus', prefix: 'fas', tags: [] },
    { name: 'fa-search-plus', prefix: 'fas', tags: [] },
    { name: 'fa-searchengin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-seedling', prefix: 'fas', tags: [] },
    { name: 'fa-sellcast', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sellsy', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-server', prefix: 'fas', tags: [] },
    { name: 'fa-servicestack', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-shapes', prefix: 'fas', tags: [] },
    { name: 'fa-share', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-share-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-share-alt-square', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-share-square', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-shekel-sign', prefix: 'fas', tags: [] },
    { name: 'fa-shield-alt', prefix: 'fas', tags: [] },
    { name: 'fa-shield-virus', prefix: 'fas', tags: [] },
    { name: 'fa-ship', prefix: 'fas', tags: [] },
    { name: 'fa-shipping-fast', prefix: 'fas', tags: [] },
    { name: 'fa-shirtsinbulk', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-shoe-prints', prefix: 'fas', tags: [] },
    { name: 'fa-shopify', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-shopping-bag', prefix: 'fas', tags: [] },
    { name: 'fa-shopping-basket', prefix: 'fas', tags: [] },
    { name: 'fa-shopping-cart', prefix: 'fas', tags: [] },
    { name: 'fa-shopware', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-shower', prefix: 'fas', tags: [] },
    { name: 'fa-shuttle-van', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-sign', prefix: 'fas', tags: [] },
    { name: 'fa-sign-in-alt', prefix: 'fas', tags: [] },
    { name: 'fa-sign-language', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-sign-out-alt', prefix: 'fas', tags: [] },
    { name: 'fa-signal', prefix: 'fas', tags: [] },
    { name: 'fa-signature', prefix: 'fas', tags: [] },
    { name: 'fa-sim-card', prefix: 'fas', tags: [] },
    { name: 'fa-simplybuilt', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sink', prefix: 'fas', tags: [] },
    { name: 'fa-sistrix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sitemap', prefix: 'fas', tags: [] },
    { name: 'fa-sith', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-skating', prefix: 'fas', tags: [] },
    { name: 'fa-sketch', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-skiing', prefix: 'fas', tags: [] },
    { name: 'fa-skiing-nordic', prefix: 'fas', tags: [] },
    { name: 'fa-skull', prefix: 'fas', tags: [] },
    { name: 'fa-skull-crossbones', prefix: 'fas', tags: [] },
    { name: 'fa-skyatlas', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-skype', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-slack', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-slack-hash', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-slash', prefix: 'fas', tags: [] },
    { name: 'fa-sleigh', prefix: 'fas', tags: [] },
    { name: 'fa-sliders-h', prefix: 'fas', tags: [] },
    { name: 'fa-slideshare', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-smile', prefix: 'fas', tags: [] },
    { name: 'fa-smile-beam', prefix: 'fas', tags: [] },
    { name: 'fa-smile-wink', prefix: 'fas', tags: [] },
    { name: 'fa-smog', prefix: 'fas', tags: [] },
    { name: 'fa-smoking', prefix: 'fas', tags: [] },
    { name: 'fa-smoking-ban', prefix: 'fas', tags: [] },
    { name: 'fa-sms', prefix: 'fas', tags: [] },
    { name: 'fa-snapchat', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-snapchat-ghost', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-snapchat-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-snowboarding', prefix: 'fas', tags: [] },
    { name: 'fa-snowflake', prefix: 'fas', tags: [] },
    { name: 'fa-snowman', prefix: 'fas', tags: [] },
    { name: 'fa-snowplow', prefix: 'fas', tags: [] },
    { name: 'fa-soap', prefix: 'fas', tags: [] },
    { name: 'fa-socks', prefix: 'fas', tags: [] },
    { name: 'fa-solar-panel', prefix: 'fas', tags: [] },
    { name: 'fa-sort', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-alpha-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-alpha-down-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-alpha-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-alpha-up-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-amount-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-amount-down-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-amount-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-amount-up-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-numeric-down', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-numeric-down-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-numeric-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-numeric-up-alt', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-sort-up', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-soundcloud', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sourcetree', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-spa', prefix: 'fas', tags: [] },
    { name: 'fa-space-shuttle', prefix: 'fas', tags: [] },
    { name: 'fa-speakap', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-speaker-deck', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-spell-check', prefix: 'fas', tags: [] },
    { name: 'fa-spider', prefix: 'fas', tags: ['nature'] },
    { name: 'fa-spinner', prefix: 'fas', tags: [] },
    { name: 'fa-splotch', prefix: 'fas', tags: [] },
    { name: 'fa-spotify', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-spray-can', prefix: 'fas', tags: [] },
    { name: 'fa-square', prefix: 'fas', tags: [] },
    { name: 'fa-square-full', prefix: 'fas', tags: [] },
    { name: 'fa-square-root-alt', prefix: 'fas', tags: [] },
    { name: 'fa-squarespace', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stack-exchange', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stack-overflow', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stackpath', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stamp', prefix: 'fas', tags: [] },
    { name: 'fa-star', prefix: 'fas', tags: [] },
    { name: 'fa-star-and-crescent', prefix: 'fas', tags: [] },
    { name: 'fa-star-half', prefix: 'fas', tags: [] },
    { name: 'fa-star-half-alt', prefix: 'fas', tags: [] },
    { name: 'fa-star-of-david', prefix: 'fas', tags: [] },
    { name: 'fa-star-of-life', prefix: 'fas', tags: [] },
    { name: 'fa-staylinked', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-steam', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-steam-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-steam-symbol', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-step-backward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-step-forward', prefix: 'fas', tags: ['media'] },
    { name: 'fa-stethoscope', prefix: 'fas', tags: [] },
    { name: 'fa-sticker-mule', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-sticky-note', prefix: 'fas', tags: [] },
    { name: 'fa-stop', prefix: 'fas', tags: ['media'] },
    { name: 'fa-stop-circle', prefix: 'fas', tags: ['media'] },
    { name: 'fa-stopwatch', prefix: 'fas', tags: [] },
    { name: 'fa-stopwatch-20', prefix: 'fas', tags: [] },
    { name: 'fa-store', prefix: 'fas', tags: [] },
    { name: 'fa-store-alt', prefix: 'fas', tags: [] },
    { name: 'fa-store-alt-slash', prefix: 'fas', tags: [] },
    { name: 'fa-store-slash', prefix: 'fas', tags: [] },
    { name: 'fa-strava', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stream', prefix: 'fas', tags: [] },
    { name: 'fa-street-view', prefix: 'fas', tags: [] },
    { name: 'fa-strikethrough', prefix: 'fas', tags: [] },
    { name: 'fa-stripe', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stripe-s', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stroopwafel', prefix: 'fas', tags: [] },
    { name: 'fa-studiovinari', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stumbleupon', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-stumbleupon-circle', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-subscript', prefix: 'fas', tags: [] },
    { name: 'fa-subway', prefix: 'fas', tags: [] },
    { name: 'fa-suitcase', prefix: 'fas', tags: [] },
    { name: 'fa-suitcase-rolling', prefix: 'fas', tags: [] },
    { name: 'fa-sun', prefix: 'fas', tags: [] },
    { name: 'fa-superpowers', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-superscript', prefix: 'fas', tags: [] },
    { name: 'fa-supple', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-surprise', prefix: 'fas', tags: [] },
    { name: 'fa-suse', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-swatchbook', prefix: 'fas', tags: [] },
    { name: 'fa-swift', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-swimmer', prefix: 'fas', tags: [] },
    { name: 'fa-swimming-pool', prefix: 'fas', tags: [] },
    { name: 'fa-symfony', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-synagogue', prefix: 'fas', tags: [] },
    { name: 'fa-sync', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-sync-alt', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-syringe', prefix: 'fas', tags: [] },
    { name: 'fa-table', prefix: 'fas', tags: [] },
    { name: 'fa-table-tennis', prefix: 'fas', tags: [] },
    { name: 'fa-tablet', prefix: 'fas', tags: [] },
    { name: 'fa-tablet-alt', prefix: 'fas', tags: [] },
    { name: 'fa-tablets', prefix: 'fas', tags: [] },
    { name: 'fa-tachometer-alt', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-tag', prefix: 'fas', tags: [] },
    { name: 'fa-tags', prefix: 'fas', tags: [] },
    { name: 'fa-tape', prefix: 'fas', tags: [] },
    { name: 'fa-tasks', prefix: 'fas', tags: [] },
    { name: 'fa-taxi', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-teamspeak', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-teeth', prefix: 'fas', tags: [] },
    { name: 'fa-teeth-open', prefix: 'fas', tags: [] },
    { name: 'fa-telegram', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-telegram-plane', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-temperature-high', prefix: 'fas', tags: [] },
    { name: 'fa-temperature-low', prefix: 'fas', tags: [] },
    { name: 'fa-tencent-weibo', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-tenge', prefix: 'fas', tags: [] },
    { name: 'fa-terminal', prefix: 'fas', tags: [] },
    { name: 'fa-text-height', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-text-width', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-th', prefix: 'fas', tags: [] },
    { name: 'fa-th-large', prefix: 'fas', tags: [] },
    { name: 'fa-th-list', prefix: 'fas', tags: [] },
    { name: 'fa-the-red-yeti', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-theater-masks', prefix: 'fas', tags: [] },
    { name: 'fa-themeco', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-themeisle', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-thermometer', prefix: 'fas', tags: [] },
    { name: 'fa-thermometer-empty', prefix: 'fas', tags: [] },
    { name: 'fa-thermometer-full', prefix: 'fas', tags: [] },
    { name: 'fa-thermometer-half', prefix: 'fas', tags: [] },
    { name: 'fa-thermometer-quarter', prefix: 'fas', tags: [] },
    { name: 'fa-thermometer-three-quarters', prefix: 'fas', tags: [] },
    { name: 'fa-think-peaks', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-thumbs-down', prefix: 'fas', tags: [] },
    { name: 'fa-thumbs-up', prefix: 'fas', tags: [] },
    { name: 'fa-thumbtack', prefix: 'fas', tags: [] },
    { name: 'fa-ticket-alt', prefix: 'fas', tags: [] },
    { name: 'fa-tiktok', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-times', prefix: 'fas', tags: [] },
    { name: 'fa-times-circle', prefix: 'fas', tags: [] },
    { name: 'fa-tint', prefix: 'fas', tags: [] },
    { name: 'fa-tint-slash', prefix: 'fas', tags: [] },
    { name: 'fa-tired', prefix: 'fas', tags: [] },
    { name: 'fa-toggle-off', prefix: 'fas', tags: [] },
    { name: 'fa-toggle-on', prefix: 'fas', tags: [] },
    { name: 'fa-toilet', prefix: 'fas', tags: [] },
    { name: 'fa-toilet-paper', prefix: 'fas', tags: [] },
    { name: 'fa-toilet-paper-slash', prefix: 'fas', tags: [] },
    { name: 'fa-toolbox', prefix: 'fas', tags: [] },
    { name: 'fa-tools', prefix: 'fas', tags: [] },
    { name: 'fa-tooth', prefix: 'fas', tags: [] },
    { name: 'fa-torah', prefix: 'fas', tags: [] },
    { name: 'fa-torii-gate', prefix: 'fas', tags: [] },
    { name: 'fa-tractor', prefix: 'fas', tags: [] },
    { name: 'fa-trade-federation', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-trademark', prefix: 'fas', tags: [] },
    { name: 'fa-traffic-light', prefix: 'fas', tags: [] },
    { name: 'fa-trailer', prefix: 'fas', tags: [] },
    { name: 'fa-train', prefix: 'fas', tags: [] },
    { name: 'fa-tram', prefix: 'fas', tags: [] },
    { name: 'fa-transgender', prefix: 'fas', tags: [] },
    { name: 'fa-transgender-alt', prefix: 'fas', tags: [] },
    { name: 'fa-trash', prefix: 'fas', tags: [] },
    { name: 'fa-trash-alt', prefix: 'fas', tags: [] },
    { name: 'fa-trash-restore', prefix: 'fas', tags: [] },
    { name: 'fa-trash-restore-alt', prefix: 'fas', tags: [] },
    { name: 'fa-tree', prefix: 'fas', tags: [] },
    { name: 'fa-trello', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-trophy', prefix: 'fas', tags: [] },
    { name: 'fa-truck', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-truck-loading', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-truck-monster', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-truck-moving', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-truck-pickup', prefix: 'fas', tags: ['travel'] },
    { name: 'fa-tshirt', prefix: 'fas', tags: [] },
    { name: 'fa-tty', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-tumblr', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-tumblr-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-tv', prefix: 'fas', tags: ['media'] },
    { name: 'fa-twitch', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-twitter', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-twitter-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-typo3', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-uber', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ubuntu', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-uikit', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-umbraco', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-umbrella', prefix: 'fas', tags: [] },
    { name: 'fa-umbrella-beach', prefix: 'fas', tags: [] },
    { name: 'fa-uncharted', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-underline', prefix: 'fas', tags: [] },
    { name: 'fa-undo', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-undo-alt', prefix: 'fas', tags: ['arrow', 'media'] },
    { name: 'fa-uniregistry', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-unity', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-universal-access', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-university', prefix: 'fas', tags: [] },
    { name: 'fa-unlink', prefix: 'fas', tags: [] },
    { name: 'fa-unlock', prefix: 'fas', tags: [] },
    { name: 'fa-unlock-alt', prefix: 'fas', tags: [] },
    { name: 'fa-unsplash', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-untappd', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-upload', prefix: 'fas', tags: ['arrow'] },
    { name: 'fa-ups', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-usb', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-user', prefix: 'fas', tags: [] },
    { name: 'fa-user-alt', prefix: 'fas', tags: [] },
    { name: 'fa-user-alt-slash', prefix: 'fas', tags: [] },
    { name: 'fa-user-astronaut', prefix: 'fas', tags: [] },
    { name: 'fa-user-check', prefix: 'fas', tags: [] },
    { name: 'fa-user-circle', prefix: 'fas', tags: [] },
    { name: 'fa-user-clock', prefix: 'fas', tags: [] },
    { name: 'fa-user-cog', prefix: 'fas', tags: [] },
    { name: 'fa-user-edit', prefix: 'fas', tags: [] },
    { name: 'fa-user-friends', prefix: 'fas', tags: [] },
    { name: 'fa-user-graduate', prefix: 'fas', tags: [] },
    { name: 'fa-user-injured', prefix: 'fas', tags: [] },
    { name: 'fa-user-lock', prefix: 'fas', tags: [] },
    { name: 'fa-user-md', prefix: 'fas', tags: [] },
    { name: 'fa-user-minus', prefix: 'fas', tags: [] },
    { name: 'fa-user-ninja', prefix: 'fas', tags: [] },
    { name: 'fa-user-nurse', prefix: 'fas', tags: [] },
    { name: 'fa-user-plus', prefix: 'fas', tags: [] },
    { name: 'fa-user-secret', prefix: 'fas', tags: [] },
    { name: 'fa-user-shield', prefix: 'fas', tags: [] },
    { name: 'fa-user-slash', prefix: 'fas', tags: [] },
    { name: 'fa-user-tag', prefix: 'fas', tags: [] },
    { name: 'fa-user-tie', prefix: 'fas', tags: [] },
    { name: 'fa-user-times', prefix: 'fas', tags: [] },
    { name: 'fa-users', prefix: 'fas', tags: [] },
    { name: 'fa-users-cog', prefix: 'fas', tags: [] },
    { name: 'fa-users-slash', prefix: 'fas', tags: [] },
    { name: 'fa-usps', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-ussunnah', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-utensil-spoon', prefix: 'fas', tags: [] },
    { name: 'fa-utensils', prefix: 'fas', tags: [] },
    { name: 'fa-vaadin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vector-square', prefix: 'fas', tags: [] },
    { name: 'fa-venus', prefix: 'fas', tags: [] },
    { name: 'fa-venus-double', prefix: 'fas', tags: [] },
    { name: 'fa-venus-mars', prefix: 'fas', tags: [] },
    { name: 'fa-vest', prefix: 'fas', tags: [] },
    { name: 'fa-vest-patches', prefix: 'fas', tags: [] },
    { name: 'fa-viacoin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-viadeo', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-viadeo-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vial', prefix: 'fas', tags: [] },
    { name: 'fa-vials', prefix: 'fas', tags: [] },
    { name: 'fa-viber', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-video', prefix: 'fas', tags: ['media'] },
    { name: 'fa-video-slash', prefix: 'fas', tags: ['media'] },
    { name: 'fa-vihara', prefix: 'fas', tags: [] },
    { name: 'fa-vimeo', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vimeo-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vimeo-v', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vine', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-virus', prefix: 'fas', tags: [] },
    { name: 'fa-virus-slash', prefix: 'fas', tags: [] },
    { name: 'fa-viruses', prefix: 'fas', tags: [] },
    { name: 'fa-vk', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-vnv', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-voicemail', prefix: 'fas', tags: [] },
    { name: 'fa-volleyball-ball', prefix: 'fas', tags: [] },
    { name: 'fa-volume-down', prefix: 'fas', tags: ['media'] },
    { name: 'fa-volume-mute', prefix: 'fas', tags: ['media'] },
    { name: 'fa-volume-off', prefix: 'fas', tags: ['media'] },
    { name: 'fa-volume-up', prefix: 'fas', tags: ['media'] },
    { name: 'fa-vote-yea', prefix: 'fas', tags: [] },
    { name: 'fa-vr-cardboard', prefix: 'fas', tags: [] },
    { name: 'fa-vuejs', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-walking', prefix: 'fas', tags: [] },
    { name: 'fa-wallet', prefix: 'fas', tags: [] },
    { name: 'fa-warehouse', prefix: 'fas', tags: [] },
    { name: 'fa-watchman-monitoring', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-water', prefix: 'fas', tags: [] },
    { name: 'fa-wave-square', prefix: 'fas', tags: [] },
    { name: 'fa-waze', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-weebly', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-weibo', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-weight', prefix: 'fas', tags: [] },
    { name: 'fa-weight-hanging', prefix: 'fas', tags: [] },
    { name: 'fa-weixin', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-whatsapp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-whatsapp-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wheelchair', prefix: 'fas', tags: ['accessibility'] },
    { name: 'fa-whmcs', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wifi', prefix: 'fas', tags: [] },
    { name: 'fa-wikipedia-w', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wind', prefix: 'fas', tags: [] },
    { name: 'fa-window-close', prefix: 'fas', tags: [] },
    { name: 'fa-window-maximize', prefix: 'fas', tags: [] },
    { name: 'fa-window-minimize', prefix: 'fas', tags: [] },
    { name: 'fa-window-restore', prefix: 'fas', tags: [] },
    { name: 'fa-windows', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wine-bottle', prefix: 'fas', tags: [] },
    { name: 'fa-wine-glass', prefix: 'fas', tags: [] },
    { name: 'fa-wine-glass-alt', prefix: 'fas', tags: [] },
    { name: 'fa-wix', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wizards-of-the-coast', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wodu', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wolf-pack-battalion', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-won-sign', prefix: 'fas', tags: [] },
    { name: 'fa-wordpress', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wordpress-simple', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wpbeginner', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wpexplorer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wpforms', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wpressr', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-wrench', prefix: 'fas', tags: [] },
    { name: 'fa-x-ray', prefix: 'fas', tags: [] },
    { name: 'fa-xbox', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-xing', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-xing-square', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-y-combinator', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yahoo', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yammer', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yandex', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yandex-international', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yarn', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yelp', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-yen-sign', prefix: 'fas', tags: [] },
    { name: 'fa-yin-yang', prefix: 'fas', tags: [] },
    { name: 'fa-yoast', prefix: 'fab', tags: ['brand'] },
    { name: 'fa-youtube', prefix: 'fab', tags: ['brand', 'media'] },
    { name: 'fa-youtube-square', prefix: 'fab', tags: ['brand', 'media'] },
    { name: 'fa-zhihu', prefix: 'fab', tags: ['brand'] }
  ]
}
